export default defineNuxtRouteMiddleware((to) => {
  // Only run on client side
  if (import.meta.server) return

  const canonicalHost = 'shiftgo.dk'
  const currentHost = window.location.hostname
  const currentProtocol = window.location.protocol
  const currentPath = to.fullPath

  // Force HTTPS
  if (currentProtocol === 'http:' && currentHost === canonicalHost) {
    return navigateTo(`https://${canonicalHost}${currentPath}`, { external: true, replace: true })
  }

  // Redirect www to non-www
  if (currentHost === `www.${canonicalHost}`) {
    return navigateTo(`https://${canonicalHost}${currentPath}`, { external: true, replace: true })
  }

  // Remove trailing slash except for root
  if (currentPath !== '/' && currentPath.endsWith('/')) {
    const pathWithoutSlash = currentPath.slice(0, -1)
    return navigateTo(pathWithoutSlash, { replace: true })
  }

  // Handle duplicate slashes in URL
  if (currentPath.includes('//')) {
    const cleanPath = currentPath.replace(/\/+/g, '/')
    return navigateTo(cleanPath, { replace: true })
  }
})